import React from 'react'
import { Link } from 'react-router-dom'
import machiningImg from '../images/Picture18.jpg'
import V2Layout from '../components/V2Layout'
import SEO from '../components/SEO'

const ApplicationsScreen = () => {
    return (
        <V2Layout pageClass="pfc-applications">
            <SEO
                title="Applications"
                description="Trusted by major commercial launch vehicle companies, NASA facilities, and defense installations across the United States."
            />
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Applications</p>
                    <h1 className="pfc-page-hero-title">Powering the Industry&apos;s Most Ambitious Programs</h1>
                    <p className="pfc-page-hero-sub">
                        Trusted by major commercial launch vehicle companies, NASA facilities,
                        and defense installations across the United States.
                    </p>
                </div>
            </section>

            <section className="v2-content v2-dark">
                <div className="v2-content-inner v2-reverse">
                    <div className="v2-content-col">
                        <p className="v2-section-label" >Who We Serve</p>
                        <h2 className="v2-content-title">Launch &amp; Ground Programs</h2>
                        <p className="v2-content-body">
                            PFC customers include most major commercial launch vehicle companies. Ground support
                            customers include NASA facilities such as Stennis Space Center, Marshall Space Flight
                            Center, and Kennedy Space Center.
                        </p>
                        <p className="v2-content-body">
                            Defense customers include Arnold Air Force Base and Edwards Air Force Base.
                        </p>
                        <div className="v2-cert-badges">
                            <span className="v2-cert-badge">AS9100D</span>
                            <span className="v2-cert-badge">ITAR Compliant</span>
                            <span className="v2-cert-badge">ISO 9001:2015</span>
                            <span className="v2-cert-badge">Made in USA</span>
                        </div>
                        <p className="v2-content-body">
                            See the <Link to="/aerospace-valves">aerospace valve types and certifications</Link> behind these programs.
                        </p>
                    </div>
                    <div className="v2-content-col">
                        <div className="v2-img-wrap">
                            <img src={machiningImg} className="v2-img" alt="CNC Machining" />
                            <div className="v2-img-caption">Mazak Live-Tool Lathe</div>
                        </div>
                    </div>
                </div>
            </section>
        </V2Layout>
    )
}

export default ApplicationsScreen
